import { isPresent } from 'ts-is-present'

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuLink,
} from ':/_console/js/components/DropdownMenu/DropdownMenu.tsx'
import { useLogoutUser } from '~/features/authentication/data.ts'
import { useWorkspace } from '~/features/workspaces/data.ts'

function DesktopUserDropdown() {
  const { data } = useWorkspace()
  const logout = useLogoutUser()
  return (
    <DropdownMenu className="dropdown-menu-temp-lakesare">
      {isPresent(data) && (
        <DropdownMenuItem
          className="text-small hr text-left text-muted"
          style={{ padding: '9px 20px', margin: 0 }}
        >
          You are logged in as <br />
          {data.login_data.email}
        </DropdownMenuItem>
      )}
      <DropdownMenuItem>
        <DropdownMenuLink to="/c/user/settings">User settings</DropdownMenuLink>
      </DropdownMenuItem>
      <DropdownMenuItem>
        <DropdownMenuLink asChild>
          <a
            href="/users/logout"
            onClick={async (event) => {
              event.preventDefault()
              await logout.execute()
            }}
          >
            Log out
          </a>
        </DropdownMenuLink>
      </DropdownMenuItem>
    </DropdownMenu>
  )
}

export default DesktopUserDropdown
